export const getScapPromotionsForDisplay = ({
    getPromotionsByScenarioId,
    scenarioId,
    includeGhostPromotions,
    promotionIdsOnDisplayAfterFilter = [],
}) => {
    const promotionsForDisplay =
        getPromotionsByScenarioId(scenarioId, includeGhostPromotions) || [];

    if (!promotionIdsOnDisplayAfterFilter.length) {
        return promotionsForDisplay;
    }

    return promotionsForDisplay.filter(promotion =>
        promotionIdsOnDisplayAfterFilter.includes(promotion._id)
    );
};

export const getScapPromotionsForAggregation = ({ promotionsForDisplay = [] }) => {
    return promotionsForDisplay.filter(promotion => !promotion.isGhost);
};
